module.exports = __webpack_public_path__ + "img/hezuo.df7bf58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/hezuo.png
// module id = 3K18
// module chunks = 0